export const SEARCH_OPTIONS = {
  keys: ["combined"],
  threshold: 0.3,
  location: 50,
  ignoreLocation: true,
  findAllMatches: true,
};
